import { common, baseComponents } from '@tencent/ceiba-base-components';
import Vue from 'vue';

let loginManagerInstance = null;
let isClientGame = 2;

const checkAccountType = () => (common.tool.getCookie('acctype') === 'wx' ? 'wx' : 'qc');

/**
 * @description 仅支持在safari浏览器可拉起微信授权登录场景
 */
function wxLoginSafari() {
  const astConfig = Vue.prototype.$ast.currentAstConfig();
  const urlTmp = `https://xinyue.qq.com/comm-htdocs/login/milosdk/wx_mobile_redirect.html?acctype=wx&appid=${astConfig.WX_SAFARI_APP_ID}&s_url=${encodeURIComponent(location.href.replace(/(code=\w+[&|#|$]*)/g, '').replace(/[&|?]$/, ''))}`; // 去除code
  window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${astConfig.WX_SAFARI_APP_ID}&redirect_uri=${encodeURIComponent(urlTmp)}&response_type=code&scope=snsapi_userinfo#wechat_redirect`;
}

function loginByQQ(loginManager) {
  const astConfig = Vue.prototype.$ast.currentAstConfig();
  if (common.platform.isMobile) {
    loginManager.mobileLoginByQQConnect({
      appId: astConfig.QC_APP_ID,
      redirectUri: astConfig.QC_REDIRECT_URI,
      sUrl: location.href,
    });
  } else {
    // pc环境打开,用pc登录方法
    loginManager.loginByQQConnect({
      appId: astConfig.QC_APP_ID,
      redirectUri: astConfig.QC_REDIRECT_URI,
      sUrl: location.href,
    });
  }
  localStorage?.setItem('curPlatform', 'qq');
}

function loginByWx(loginManager) {
  // pc微信登录需要用网页应用appid,不能用服务号appid,所以微信登录暂时不做处理
  const astConfig = Vue.prototype.$ast.currentAstConfig();
  if (common.platform.isSafari) {
    wxLoginSafari();
  } else {
    loginManager.mobileLoginByWX({
      appId: common.platform.isSafari ? astConfig.WX_SAFARI_APP_ID : astConfig.WX_APP_ID, // safari用游戏家公会,其他默认用心悦公众号
      scope: 'snsapi_userinfo', // 默认是 snsapi_base 静默授权，如果游戏无静默权限，就需要手动改成 snsapi_userinfo
      userinfoSpan: 'userinfo',
      forcePopup: true,
      snapShotTips: true,
      snapShotCustomTips: '我同意“本活动获取您的个人信息，仅用于该活动的查询、抽奖、领取、发货、签到等操作”',
    });
  }
  localStorage?.setItem('curPlatform', 'wx');
}
export default {
  /**
   * 心悦登录特点
   * 游戏：只有手游，没有端游
   * 注销：APP里没有登出操作
   * 自动登录:QQ浏览器pt登录，微信则wx登录
   * 心悦APP内QQ默认用QC互联登录
   */
  initLogin: async () => {
    const astConfig = Vue.prototype.$ast.currentAstConfig();
    switch (astConfig.NAME) {
      case 'SPARK': {
        isClientGame = Vue.prototype.$actInfo.game_type;
        if (isClientGame === 1 && checkAccountType() === 'wx') {
          // 端游
          alert('该活动仅限QQ用户参与，请重新切换账号');
          return;
        }
        break;
      }
      default:
        break;
    }
    window.ams_login_avoid_conflict = true;
    // 为了兼容qq客户端内打开,需要手动清除pt登录的cookie
    common.tool.clearCookie('uin');
    common.tool.clearCookie('skey');
    // window.iUseQQConnect = common.tool.getCookie('acctype') === 'qc' ? 1 : 0;
    // 因为midas只支持qc登录态,所以心悦先强制qc.
    window.iUseQQConnect = 1;
    loginManagerInstance = new Vue.prototype.$miloLoginManager({
      commonParams: {
        iUseQQConnect: window.iUseQQConnect,
        useAppLogin: astConfig.NAME === 'TGCLUB' ? ['tgclub'] : [],
      },
      mobileParams: {
        oWXParams: {
          gameDomain: astConfig.WX_GAME_DOMAIN,
          appId: common.platform.isSafari ? astConfig.SHARE_WX_APP_ID : astConfig.WX_APP_ID,
          scope: 'snsapi_userinfo',
        },
        oQQConnectParams: {
          appId: astConfig.QC_APP_ID,
          redirectUri: astConfig.QC_REDIRECT_URI,
          sUrl: location.href,
        },
      },
    });
    return 'ok';
  },
  /**
   * 去登录操作
   * @param {登录方式} loginType
   */
  login: async (params = { loginType: 'qq' }) => {
    if (params.loginType === 'qq') loginByQQ(loginManagerInstance);
    if (params.loginType === 'wx') loginByWx(loginManagerInstance);
  },
  /**
   * 检查登录信息，返回是否登录+登录信息
   * @returns {
   *  "isLogin":true,
   *  "userInfo":{}
   * }
   */
  checkLogin: async () => {
    const astConfig = Vue.prototype.$ast.currentAstConfig();
    const cookieAcctype = common.tool.getCookie('acctype');
    if (!Boolean(cookieAcctype) || cookieAcctype === 'pt') {
      // cookie中没有acctype,异或acctype为pt则非法,直接返回未登录
      return {
        isLogin: false,
        userInfo: {},
      };
    }
    if (location.href.indexOf('FLUSH_COOKIE=') > 0) {
      common.tool.clearAllCookie();
      let newHref = location.href;
      newHref = common.tool.delHrefParam('FLUSH_COOKIE', '', newHref);
      location.href = newHref;
    }
    switch (astConfig.NAME) {
      case 'SUPERCORE': {
        const appid = common.tool.getQueryparams('appid');
        const openid = common.tool.getQueryparams('openid');
        const acctype = common.tool.getQueryparams('acctype');
        const accessToken = common.tool.getQueryparams('access_token');
        if (appid && openid && acctype && accessToken) {
          // 写cookie
          let changeAcctype = acctype;
          if (acctype === 'qq' && accessToken.length > 10) changeAcctype = 'qc';
          if (acctype === 'weixin') changeAcctype = 'wx';
          common.tool.setCookie('appid', appid);
          common.tool.setCookie('openid', openid);
          common.tool.setCookie('acctype', changeAcctype);
          common.tool.setCookie('access_token', accessToken);
          return {
            isLogin: true,
            userInfo: {
              nickName: common.tool.getQueryparams('nickname') || '当前用户',
            },
          };
        }
        break;
      }
      default:
        break;
    }
    try {
      const checkRes = await loginManagerInstance.checkRealLogin();
      const { isLogin, userInfo, result } = checkRes;
      if (userInfo) {
        userInfo.avatar = userInfo?.avatarUrl ?? userInfo?.formatUserInfo?.avatarUrl;
      }
      // 同步一份loginType到userInfo,兼容旧组件逻辑
      userInfo.loginType = result?.loginType;
      // 采用localStorage 保持登录的连续性 保持活动页面上一次保持登录的方式
      //
      let curPlatform = localStorage?.getItem('curPlatform');
      if (!curPlatform) {
        curPlatform = Vue.prototype.$platform.isWX ? 'wx' : 'qq';
      }
      if (Vue.prototype.$ast.isAPP()) {
        curPlatform = checkAccountType();
      }
      localStorage?.setItem('curPlatform', curPlatform);
      return {
        isLogin,
        userInfo,
      };
    } catch (err) {
      console.error('checkRealLogin Failed Code:', err.errCode);
      console.error('checkRealLogin Failed info:', err.errInfo);
      common.tool.clearAllCookie();
      switch (astConfig.NAME) {
        case 'GBOT':
        case 'BB': {
          const { isQQ, isWX } = Vue.prototype.$platform;
          const { game_type: gameType = 0 } = Vue.prototype.$actInfo || {};
          isQQ && loginByQQ(loginManagerInstance);
          isWX && gameType !== 1 && loginByWx(loginManagerInstance);
          break;
        }
        default:
          break;
      }
      return {
        isLogin: false,
        userInfo: {},
      };
    }
  },
  /**
   * 登出操作
   */
  logout: async () => {
    await loginManagerInstance.logout().then((res) => {
      console.log('tgclub user logout res:', res);
      common.tool.clearAllCookie();
      localStorage?.setItem('curPlatform', '');
      sessionStorage?.setItem('logouted', 'true');
    });
  },
  /**
   * 获取角色信息
   */
  checkRoleInfo: async () => {
    const astConfig = Vue.prototype.$ast.currentAstConfig();
    let hasRole = false;
    let roleInfo = '';
    switch (astConfig.NAME) {
      case 'SUPERCORE': {
        const localRoleKey = `ceiba-${Vue.prototype.$actInfo.activity_id}-${Vue.prototype.$actInfo.game_code}`;
        let localRole = localStorage?.getItem(localRoleKey);
        localRole = JSON.parse(localRole) || {
          gameCode: null,
          sArea: null,
          sPartition: null,
          sRoleId: null,
        };
        console.log('ceiba-localStroage-role ==', localRole);

        const { gameCode, sPartition, sRoleId } = localRole;
        try {
          // localStorage里有角色,再去校验角色合法性
          if (sRoleId) {
            const roleList = await baseComponents.Apis.Role.fetch({
              game_code: gameCode,
              partition_id: sPartition,
              device: common.platform.device,
            });
            console.log('fetch roleList = ', roleList);
            roleInfo = roleList.find((e) => {
              if (e.role_id === sRoleId) return true;
              if (e.game_open_id === e.role_id) return true;
              if (e.game_open_id === decodeURI(e.role_id)) return true;
              return false;
            });
            if (roleInfo) {
              hasRole = true;
            }
          } else {
            console.log('fetch current roleInfo vacancy');
          }
        } catch (e) {
          console.error('fetch roleList fail, e=', e);
        }
        break;
      }
      case 'BB': {
        if (Vue.prototype.$ast.isAPP()) {
          try {
            const partition = common.tool.getQueryparams('serverId') || 0;
            const roleid = common.tool.getQueryparams('role') || common.tool.getQueryparams('roleid')
              || common.tool.getQueryparams('role_id') || common.tool.getQueryparams('roleId')
              || common.tool.getQueryparams('sRole') || common.tool.getQueryparams('sRoleId')
              || common.tool.getQueryparams('charac_no');
            const areaid = common.tool.getQueryparams('areaId') || 'others';
            if (roleid && areaid) {
              let device;
              if (parseInt(Vue.prototype.$actInfo?.gid, 10) === 1194) {
                switch (areaid) {
                  case '1':
                  case '2':
                    device = 'android';
                    break;
                  case '3':
                  case '4':
                    device = 'ios';
                    break;
                  default:
                    device = 'others';
                    break;
                }
              } else {
                switch (areaid) {
                  case '1':
                  case '3':
                    device = 'ios';
                    break;
                  case '2':
                  case '4':
                    device = 'android';
                    break;
                  default:
                    device = 'others';
                    break;
                }
              }
              // 校验url上角色数据的正确性
              const roleList = await baseComponents.Apis.Role.fetch({
                game_code: Vue.prototype.$actInfo.game_code,
                partition_id: partition,
                device,
              });
              const roleInfo = roleList.find((e) => {
                if (e.role_id === roleid) return true;
                if (e.game_open_id === e.role_id) return true;
                if (e.game_open_id === decodeURI(e.role_id)) return true;
                return false;
              });
              console.log('fetch roleList = ', roleInfo);
              if (roleInfo) {
                hasRole = true;
              }
            }
          } catch (e) {
            console.log('checkRole fail ', e);
            const loginInvalidRet = [7001, 7002, 7003, 7004, 7005, 7006, 7007, 7008, 7551];
            if (loginInvalidRet.includes(e.data.ret)) {
              Vue.prototype.alert('登录态过期，请退出重新登录！');
            }
          }
        }
        break;
      }
      default:
        break;
    }
    if (hasRole === true) {
      return {
        defaultPlugin: false,
        isRoleReady: true,
        roleInfo,
      };
    }
    return {
      defaultPlugin: true,
      isRoleReady: false,
      roleInfo: {},
    };
  },
};
